/**
 * Plan-level constants. Four tiers: Basic, Luxe, Pro, Enterprise.
 * Currently we only build Basic and Luxe. Pro and Enterprise are reserved for future use.
 *
 * - Basic: Dashboard + manual report upload (on dashboard), Revenue Recovery, Payment Match + Settings only.
 *   No access to Commission Tracker page, Carrier Auto-Sync, Analytics, Reports. Badge: "Agent".
 * - Luxe (current premium): Full UI, all tools, Forest Green palette. Badge: "Luxe Agent".
 * - Pro: (future)
 * - Enterprise: (future)
 *
 * Luxe users must never see Basic fallbacks. Basic users must not have access to Luxe-only routes.
 */

export type PlanTier = 'Basic' | 'Luxe' | 'Pro' | 'Enterprise';

/** Current premium plan name. Use this for overrides and new premium grants. */
export const PLAN_LUXE = 'Luxe' as const;

/** Plan values that grant Luxe access (Luxe = current premium; Pro/Enterprise kept for backward compat if present in DB). */
export const LUXE_PLAN_VALUES: readonly PlanTier[] = ['Luxe', 'Pro', 'Enterprise'];

export const PLAN_LEVEL_BASIC = 'Basic' as const;

export function isLuxePlan(plan: string | null | undefined): boolean {
  return plan === 'Luxe' || plan === 'Pro' || plan === 'Enterprise';
}

export function isBasicPlan(plan: string | null | undefined): boolean {
  return plan === 'Basic';
}
